import { useRef, useState, useEffect } from "react";
import { getImageUrl } from "../../final-qa/lib/productData";
import { NO_IMAGE_URL, VARIATIONS } from "../lib/constants";

export const useImageCompare = (intakeProductId, productShots, selectedProductCompare, isDuplicateStaging) => {
    const [duplicateStageImageList, setDuplicateStageImageList] = useState([]);

    const createProductImageVariant = (productId, urlId, editedImageUris, uneditedImageUris, name, locale) => {
        return {
            productId,
            variation: {
                urlId,
                editedImageUris,
                uneditedImageUris,
                name,
                locale,
            },
        };
    };

    const getImageUris = (edited, unedited) => {
        if (edited) {
            return edited.normal;
        }

        if (isDuplicateStaging && unedited) {
            return unedited.normal;
        }

        return NO_IMAGE_URL;
    };

    useEffect(() => {
        if (isDuplicateStaging && selectedProductCompare) {
            const formattedImages = selectedProductCompare.images.map(({ imageViewDescription, editedImageUris, uneditedImageUris, imageView }) => {
                const imageUrl = getImageUris(editedImageUris, uneditedImageUris);

                return createProductImageVariant(
                    selectedProductCompare.taskContextKey,
                    imageUrl,
                    editedImageUris,
                    uneditedImageUris,
                    imageViewDescription || imageView
                );
            });

            return setDuplicateStageImageList(formattedImages);
        }
    }, [isDuplicateStaging, selectedProductCompare]);

    const imagesRef = useRef({
        intakeProducts:
            productShots &&
            productShots.map(({ imageView, imageViewDescription, editedImageUris, uneditedImageUris, locale }) => {
                const imageUrl = getImageUris(editedImageUris, uneditedImageUris);

                return createProductImageVariant(
                    intakeProductId,
                    imageUrl,
                    editedImageUris,
                    uneditedImageUris,
                    imageViewDescription || (isDuplicateStaging && imageView),
                    locale
                );
            }),
        cxhMatches: selectedProductCompare.images.map(({ cxhAssetName, cxHImageAttributeValue }) => {
            return createProductImageVariant(selectedProductCompare.productId, getImageUrl(cxHImageAttributeValue), null, null, cxhAssetName);
        }),
    });
    const [selectedImages, setSelectedImages] = useState([VARIATIONS.Front, VARIATIONS.Front]);

    const handleImageSelect = (intakeProductImage, matchProductImage) => {
        if (intakeProductImage) {
            setSelectedImages(([, stateMatchProductName]) => {
                return [handleCodingImageSelect(intakeProductImage), stateMatchProductName];
            });

            return;
        }

        setSelectedImages(([stateIntakeProductName]) => {
            return [stateIntakeProductName, handleCodingImageSelect(matchProductImage)];
        });
    };

    const handleCodingImageSelect = (product) => {
        if (product.variation.name === "Coding") {
            return `${product.variation.name}_${product.variation.urlId}`;
        }

        return product.variation.name;
    };

    const handleQuickCompare = (intakeProductName, matchProductName) => setSelectedImages([intakeProductName, matchProductName]);

    return {
        intakeProducts: imagesRef.current.intakeProducts,
        cxhMatches: imagesRef.current.cxhMatches,
        duplicateStageMatches: duplicateStageImageList,
        selectedImages,
        selectImage: handleImageSelect,
        checkCodingImageSelect: handleCodingImageSelect,
        quickCompare: handleQuickCompare,
        createPlaceholder: createProductImageVariant,
    };
};
